import { lazy as reactLazy } from 'react';
var DynamicContactUs$27 = reactLazy(() => import('../ContactUs/contactUs'));
var DynamicCartRedirect$26 = reactLazy(() => import('../CartRedirect/cartRedirect'));
var DynamicFAQ$25 = reactLazy(() => import('../Faq/faq'));
var DynamicSezzlePaymentCanceled$24 = reactLazy(() => import('../SezzlePaymentCancelPage/sezzlePaymentCancelPage'));
var DynamicSezzleCompletePage$23 = reactLazy(() => import('../SezzleCompletePage/sezzleCompletePage'));
var DynamicOrderConfirmationPage$22 = reactLazy(() => import('../CheckoutPage/OrderConfirmationPage/orderConfirmationPage'));
var DynamicGiftCardBalance$21 = reactLazy(() => import('../GiftCardBalance'));
var DynamicSpinTheWheel$20 = reactLazy(() => import('../SpinTheWheel'));
var DynamicStorePage$19 = reactLazy(() => import('../StorePage'));
var DynamicGlobalStoreLocator$18 = reactLazy(() => import('../GlobalStoreLocatorPage'));
var DynamicCareersItem$17 = reactLazy(() => import('../CareersItem'));
var DynamicWishlistProducts$16 = reactLazy(() => import('../WishlistProducts'));
var DynamicMyAccount$15 = reactLazy(() => import('../MyAccount'));
var DynamicForgotPassword$14 = reactLazy(() => import('../ForgotPassword'));
var DynamicSignIn$13 = reactLazy(() => import('../SignIn'));
var DynamicWriteReview$12 = reactLazy(() => import('../WriteReview'));
var DynamicWishlistPage$11 = reactLazy(() => import('../WishlistPage'));
var DynamicSearch$10 = reactLazy(() => import('../../RootComponents/Search'));
var DynamicSavedPayments$9 = reactLazy(() => import('../SavedPaymentsPage'));
var DynamicResetPassword$8 = reactLazy(() => import('../MyAccount/ResetPassword'));
var DynamicOrderHistory$7 = reactLazy(() => import('../OrderHistoryPage'));
var DynamicCreateAccountPage$6 = reactLazy(() => import('../CreateAccountPage'));
var DynamicCommunicationsPage$5 = reactLazy(() => import('../CommunicationsPage'));
var DynamicCheckoutPage$4 = reactLazy(() => import('../CheckoutPage'));
var DynamicCart$3 = reactLazy(() => import('../CartPage'));
var DynamicAddressBook$2 = reactLazy(() => import('../AddressBookPage'));
var DynamicAccountInformationPage$1 = reactLazy(() => import('../AccountInformationPage'));
import React, { Suspense } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { fullPageLoadingIndicator } from '../LoadingIndicator';
import HomePage from '../HomePage';
import MagentoRoute from '../MagentoRoute';
import { useScrollTopOnChange } from '@magento/peregrine/lib/hooks/useScrollTopOnChange';
var Routes = () => {
  var {
    pathname: pathWithoutStoreCode
  } = useLocation();
  useScrollTopOnChange(pathWithoutStoreCode);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: fullPageLoadingIndicator
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/(contact-us|contactez-nous)"
  }, /*#__PURE__*/React.createElement(DynamicContactUs$27, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/reclaim/checkout/cart"
  }, /*#__PURE__*/React.createElement(DynamicCartRedirect$26, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/faq"
  }, /*#__PURE__*/React.createElement(DynamicFAQ$25, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/sezzle/payment/cancel"
  }, /*#__PURE__*/React.createElement(DynamicSezzlePaymentCanceled$24, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/sezzle/payment/complete"
  }, /*#__PURE__*/React.createElement(DynamicSezzleCompletePage$23, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/success/:id"
  }, /*#__PURE__*/React.createElement(DynamicOrderConfirmationPage$22, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/(gift-card-balance|solde-carte-cadeau)"
  }, /*#__PURE__*/React.createElement(DynamicGiftCardBalance$21, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/promotion-game"
  }, /*#__PURE__*/React.createElement(DynamicSpinTheWheel$20, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/(store|magasin)"
  }, /*#__PURE__*/React.createElement(DynamicStorePage$19, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/(store-locator|magasin-localisateur)"
  }, /*#__PURE__*/React.createElement(DynamicGlobalStoreLocator$18, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/(careers|carrieres)/:jobId"
  }, /*#__PURE__*/React.createElement(DynamicCareersItem$17, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/code/:listId"
  }, /*#__PURE__*/React.createElement(DynamicWishlistProducts$16, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/my-account"
  }, /*#__PURE__*/React.createElement(DynamicMyAccount$15, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/forgot-password"
  }, /*#__PURE__*/React.createElement(DynamicForgotPassword$14, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/sign-in"
  }, /*#__PURE__*/React.createElement(DynamicSignIn$13, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/write-a-review/:sku"
  }, /*#__PURE__*/React.createElement(DynamicWriteReview$12, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/wishlist"
  }, /*#__PURE__*/React.createElement(DynamicWishlistPage$11, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/search.html"
  }, /*#__PURE__*/React.createElement(DynamicSearch$10, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/saved-payments"
  }, /*#__PURE__*/React.createElement(DynamicSavedPayments$9, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/account/createPassword"
  }, /*#__PURE__*/React.createElement(DynamicResetPassword$8, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/order-history"
  }, /*#__PURE__*/React.createElement(DynamicOrderHistory$7, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/create-account"
  }, /*#__PURE__*/React.createElement(DynamicCreateAccountPage$6, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/communications"
  }, /*#__PURE__*/React.createElement(DynamicCommunicationsPage$5, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/checkout"
  }, /*#__PURE__*/React.createElement(DynamicCheckoutPage$4, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/cart"
  }, /*#__PURE__*/React.createElement(DynamicCart$3, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/address-book"
  }, /*#__PURE__*/React.createElement(DynamicAddressBook$2, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/account-information"
  }, /*#__PURE__*/React.createElement(DynamicAccountInformationPage$1, null)), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(MagentoRoute, null), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(HomePage, null)))));
};
export default Routes;